<template>
  <div class="container-fluid">
    <div class="row page-footer" ref="footer">
      <div class="col-12">
        <div class="row d-md-none" @click="toggle()">
          <div class="col-12 text-center burger-icon">
            <i v-if="closed" class="fas fa-angle-double-up text-white"></i>
            <i v-else class="fas fa-angle-double-down text-white"></i>
          </div>
        </div>
        <div v-if="!closed" class="row">
          <div class="col-12 pt-2">
            <nav class="navbar navbar-expand-md navbar-primary">
              <slot></slot>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { catchOutsideClicks } from "@/js/bodyClick.js";

export default {
  data() {
    return {
      closed: true,
      mobileSize: 767
    };
  },
  methods: {
    toggle() {
      this.closed = !this.closed;
    },
    isMobile() {
      return window.innerWidth < this.mobileSize;
    },
    updateMobile() {
      // check whether its mobile or not
      this.closed = window.innerWidth <= this.mobileSize;
    }
  },
  updated() {
    this.isMobile ? window.scrollTo(0, document.body.scrollHeight) : null;
  },
  created() {
    this.updateMobile();
    window.addEventListener("resize", () => {
      this.updateMobile();
    });
    catchOutsideClicks(this.$refs.footer, () => {
      if (this.isMobile()) this.closed = true;
    });
  }
};
</script>
